module.exports = __webpack_public_path__ + "static/img/pgghan.99780bc1.png";